var util = require('util');

module.exports = UploadError;


function UploadError(message, status) {
  Error.call(this);
  this.message = message;
  this.status = status || null;
}
util.inherits(UploadError, Error);



//////////////////
// WEBPACK FOOTER
// ./~/html5-uploader/lib/errors/upload-error.js
// module id = 394
// module chunks = 0